import * as React from 'react';
import MuiLink, { LinkProps as MuiLinkProps } from '@material-ui/core/Link';

import styled from 'styled-components';

const StyledLink = styled(MuiLink).attrs(props => ({
    href: props.href ?? '#',
}))`
    font-family: ${({ theme }) => theme.typography.button.fontFamily};
    text-decoration: underline;
`;

export type DSLinkProps = Omit<MuiLinkProps, 'component'>;

export const DSLink: React.FC<DSLinkProps> = props => <StyledLink {...props} />;
DSLink.displayName = 'DSLink';
